import { Controller } from "@hotwired/stimulus";
import { ProductUpdateReadProgress } from "../lib/product_update_read.mjs";

export default class extends Controller {
  static values = { url: String };

  connect() {
    if (!this.hasUrlValue || this.element.dataset.productUpdateReadSent === "true") return;

    this.progress = new ProductUpdateReadProgress();
    this.pending = false;
    this.attempts = 0;
    this.connected = true;
    this.timer = window.setInterval(() => this.sample(), 1000);
  }

  disconnect() {
    this.connected = false;
    window.clearInterval(this.timer);
    this.request?.abort();
  }

  sample() {
    const rect = this.element.getBoundingClientRect();
    this.progress.sample({
      visible: document.visibilityState === "visible",
      seconds: 1,
      top: rect.top,
      bottom: rect.bottom,
      height: rect.height,
      viewportHeight: window.innerHeight,
    });
    if (this.progress.ready && !this.pending && this.attempts < 3) this.report();
  }

  async report() {
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content;
    if (!csrf) return;

    this.pending = true;
    this.attempts += 1;
    this.request = new AbortController();
    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": csrf, Accept: "application/json" },
        body: JSON.stringify(this.progress.payload),
        signal: this.request.signal,
      });
      if (response.ok) {
        this.element.dataset.productUpdateReadSent = "true";
        window.clearInterval(this.timer);
      } else if (response.status < 500) {
        // Expired sessions, unpublished articles and invalid requests are not retried.
        window.clearInterval(this.timer);
      }
    } catch (error) {
      // Analytics must never interrupt reading. Bounded retries on subsequent ticks.
      if (error.name !== "AbortError") console.warn("Product update read event could not be recorded.");
    } finally {
      this.pending = false;
      if (!this.connected || this.attempts >= 3) window.clearInterval(this.timer);
    }
  }
}
